(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Loader"]) return;
  try {
    

var section = document.querySelector('#shopify-section-Loader');
document.addEventListener('shopify:section:select', function(e) {
 if(e.target == section) {
 document.body.classList.add('editing', 'editloader');
     document.addEventListener("shopify:section:deselect" ,function(e){
       if(e.target == section) {
         document.body.classList.remove('editloader');
       }
     });   
  }
})



  } catch(e) { console.error(e); }
})();
})();
